import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import i18next from 'i18next';

import './BrandColorPicker.scss';

class BrandColorPicker extends Component {
    state = { color: undefined };

    onColorChange = color => {
        this.setState({ color: undefined });
        this.props.onColorChange(color);
    }

    renderButton(type) {
        return (
            <Button 
                icon={type}
                style={{ borderRadius: 4, background: 'transparent', color: 'white', textShadow: '1px 1px 1px black', margin: 0, height: '100%', opacity: this.state.color ? 1 : 0 }}
                onClick={() => {
                    if (this.state.color) {
                        type === 'undo' ? this.setState({ color: undefined }) : this.onColorChange(this.state.color);
                    }
                }}
            >
            </Button>
        );
    }

    render() {
        const color = this.state.color || this.props.color;

        return (
            <div className="input-color-container" style={{ backgroundColor: color }}>
                {this.renderButton('undo')}
                <label className="input-color-label" style={{ backgroundColor: color }}>
                    {this.props.text}
                    <input className="input-color" type="color" value={color} onChange={e => this.setState({ color: e.target.value })}/>
                </label>
                {this.renderButton('check')}
            </div>
        );
    }
}

BrandColorPicker.propTypes = {
    
    onColorChange: PropTypes.func,
    text: PropTypes.string,
    color: PropTypes.string
};

export default BrandColorPicker;
